import $ from "jquery";

function initializeMap() {
    dispatchEvent(new CustomEvent("map:init"));

    // Wait for map to be ready
    window.addEventListener("map:ready", () => {
        dispatchEvent(
            new CustomEvent("map:update-points", {
                detail: { points: window.FEATURED_TEMPLATES },
            }),
        );
    });
}

$(() => {
    if (window.FEATURED_TEMPLATES && window.FEATURED_TEMPLATES.length > 0) {
        // Attach handler to initialize map
        $("[data-init-map]").on("click tap", initializeMap);
    }
});

$(".sb_featured-templates_items").on("dragStart.flickity", (event) => {
    $("body").addClass("s_is-dragging");
    $(event.currentTarget).addClass("s_is-dragging");
});

$(".sb_featured-templates_items").on("dragEnd.flickity", (event) => {
    $("body").removeClass("s_is-dragging");
    $(event.currentTarget).removeClass("s_is-dragging");
});

/**
 * Days filter (product-overview layout) — toggle chips and hide non-matching cards inline.
 * Each range chip carries data-filter-min / data-filter-max (no max = "and more"); cards expose
 * data-template-days. The catch-all chip (data-filter-other) shows every card that no other
 * range chip matches.
 */
function getChipBounds($chip) {
    const max = parseInt($chip.attr("data-filter-max"), 10);
    return {
        min: parseInt($chip.attr("data-filter-min"), 10),
        max: Number.isNaN(max) ? Infinity : max,
    };
}

function isInBounds(days, bounds) {
    return !Number.isNaN(days) && days >= bounds.min && days <= bounds.max;
}

function applyDaysFilter($section, $chip) {
    $section.find("[data-filter-range]").removeClass("s_active").attr("aria-pressed", "false");
    $chip.addClass("s_active").attr("aria-pressed", "true");

    const isOther = $chip.is("[data-filter-other]");
    const bounds = getChipBounds($chip);
    const rangeBounds = $section
        .find("[data-filter-range]")
        .not("[data-filter-other]")
        .map(function () {
            return getChipBounds($(this));
        })
        .get();

    $section.find(".sb_template-item").each(function () {
        const days = parseInt($(this).attr("data-template-days"), 10);
        const inRange = isOther
            ? !rangeBounds.some((range) => isInBounds(days, range))
            : isInBounds(days, bounds);
        $(this).toggleClass("s_is-hidden", !inRange);
    });
}

$('[data-s-type="featured-templates"]').on(
    "click tap",
    "[data-filter-range]",
    function () {
        const $chip = $(this);
        const $section = $chip.closest('[data-s-type="featured-templates"]');
        applyDaysFilter($section, $chip);
    },
);

/**
 * On load, apply the server-rendered active filter so the initial visible
 * set matches the default range chosen by PHP (smallest applicable, or the
 * destination's preference if it has matching templates).
 */
$(() => {
    $("[data-days-filter]").each(function () {
        const $filter = $(this);
        const $section = $filter.closest('[data-s-type="featured-templates"]');
        const $active = $filter.find("[data-filter-range].s_active").first();
        if ($active.length === 0) {
            return;
        }
        applyDaysFilter($section, $active);
    });
});
